import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "components/app/dialog/dialog";
import { Button } from "components/ui/button";
import { X, Loader } from "lucide-react";
import { useState } from "react";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { Service } from "utils/services";
import { AppLog } from "services";
import { ScrollArea } from "components/ui/scroll-area";

interface DialogProps {
  onUploadSuccess: (value: any) => void;
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;
  soundData: any;
}

export default function DialogSendReviewMusicCopyright({ isDialogOpen, setIsDialogOpen, onUploadSuccess, soundData }: DialogProps) {
  const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false);

  const handleSubmit = async () => {
    setLoadingSubmit(true);
    try {
      let url: string = "";
      url = RouteApi.submitSendReviewMusic;
      url += `token=${Service.token}`;
      const data = {
        sound_id: soundData?.sound_id,
      };

      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            onUploadSuccess(responses.music);
            setIsDialogOpen(false);
          } else {
          }
        })
        .catch((err) => {});
    } catch (error) {
      AppLog.show({
        message: `[handleSubmit]`,
        status: StatusMsg.error,
        error,
      });
    } finally {
      setLoadingSubmit(false);
    }
  };

  return (
    <Dialog open={isDialogOpen}>
      <DialogContent isShowBtnXClose={false} className="h-[calc(100vh-80px)] w-full md:max-w-[600px] lg:max-w-[1000px] flex flex-col justify-between p-0">
        <DialogHeader className="mt-4 border-b-2 pb-4">
          <DialogTitle className="text-center">Send Review Music Copyright</DialogTitle>
          <div
            className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
            onClick={() => setIsDialogOpen(false)}
          >
            <X />
          </div>
        </DialogHeader>
        <ScrollArea className="h-full px-4">
          <h1>
            <span className="font-semibold">Subject: </span>
            <span>Music Submission Request for FlipFlop Review</span>
          </h1>
          <br />
          <h1 className="font-semibold">Dear FlipFlop Music Review Team,</h1>
          <br />
          <p>I hope this message finds you well. I would like to submit my music for review and approval on FlipFlop. Below are the details of my submission:</p>

          <br />
          <ul className="list-disc pl-5 space-y-2">
            <li>
              <span className="font-semibold">Artist Name:</span> {soundData.singer}
            </li>
            <li>
              <span className="font-semibold">Track Title:</span> {soundData.sound_title}
            </li>
            <li>
              <span className="font-semibold">Genre:</span> {soundData.sound_genres}
            </li>
            <li>
              <span className="font-semibold">Copyright & Legal Responsibility:</span>
            </li>
            <ul className="list-disc pl-5 space-y-2">
              <li>This track is [original/composed by me/sample-based with proper licensing].</li>
              <li>I confirm that I hold all necessary rights to this music and that it does not infringe on any third-party copyrights.</li>
              <li>If required, I can provide copyright registration details or proof of ownership.</li>
              <li>
                I acknowledge that I am solely responsible for any legal claims, disputes, or violations arising from this submission. FlipFlop shall not be held liable for any
                copyright infringements, and I agree to indemnify FlipFlop against any legal consequences resulting from my submission.
              </li>
            </ul>
          </ul>
          <br />
          <p>Please let me know if any additional information is required. I look forward to your feedback and appreciate your time in reviewing my submission.</p>

          <br />
          <p>Best regards,</p>
          <p>{Service.userAuth.name}</p>
        </ScrollArea>
        <DialogFooter className="flex justify-between gap-3">
          <Button disabled={loadingSubmit} onClick={handleSubmit} className="bg-blue-600 text-white w-full hover:bg-blue-500 mt-3">
            {loadingSubmit ? <Loader className="animate-spin" /> : "Save"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
